export default "__VITE_ASSET__sX$SMYwL__"